// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";

function initial(request_id) {
  return {
    pat: "",
    request_id,
    version: undefined,
    connected: undefined,
    loading: true,
    pending: false,
    disconnecting: false,
    message: "",
    waiting: 0,
    error: undefined
  };
}

function update(t, message) {
  if (/* tag */ typeof message !== "object" && typeof message !== "function") {
    if (message === /* Loading */ 4) {
      return {
        pat: t.pat,
        request_id: t.request_id,
        version: t.version,
        connected: t.connected,
        loading: true,
        pending: t.pending,
        disconnecting: t.disconnecting,
        message: "",
        waiting: t.waiting,
        error: t.error
      };
    } else {
      return t;
    }
  }
  switch (message.TAG) {
    case /* Edited */ 2 :
      const request_id = message._2;
      const t_pat = t.pat;
      const t_version = t.version;
      const t_connected = t.connected;
      const t_loading = t.loading;
      const t_pending = t.pending;
      const t_waiting = t.waiting;
      const t_error = t.error;
      return {
        pat: message._1,
        request_id,
        version: t_version,
        connected: t_connected,
        loading: t_loading,
        pending: t_pending,
        disconnecting: false,
        message: "",
        waiting: t_waiting,
        error: t_error
      };
    case /* Loaded */ 3 :
      const json = message._0;
      const binding = Mapre_wire__Json.get(json, "binding");
      const sync = Mapre_wire__Json.get(json, "sync");
      const connected = Caml_obj.caml_equal(binding, null) ? undefined : Mapre_wire__Json.string(binding, "graph_id");
      return {
        pat: "",
        request_id: message._1,
        version: Mapre_wire__Json.integer(json, "version"),
        connected,
        loading: false,
        pending: false,
        disconnecting: false,
        message: "",
        waiting: Mapre_wire__Json.integer(sync, "pending"),
        error: Js__Js_json.decodeString(Mapre_wire__Json.get(sync, "last_error"))
      };
    case /* Pending */ 4 :
      return {
        pat: t.pat,
        request_id: message._0,
        version: t.version,
        connected: t.connected,
        loading: t.loading,
        pending: true,
        disconnecting: message._1,
        message: "",
        waiting: t.waiting,
        error: t.error
      };
    case /* Failed */ 5 :
      return {
        pat: t.pat,
        request_id: t.request_id,
        version: t.version,
        connected: t.connected,
        loading: false,
        pending: false,
        disconnecting: t.disconnecting,
        message: message._0,
        waiting: t.waiting,
        error: t.error
      };
    default:
      return t;
  }
}

function can_save(t) {
  if (!t.loading && !t.pending && t.version !== undefined) {
    return t.pat.length >= 8;
  } else {
    return false;
  }
}

export {
  initial,
  update,
  can_save,
}
/* Mapre_wire__Json Not a pure module */
